var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleUnverified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 2382.4 2500",
    viewBox: "0 0 2382.4 2500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1862.6 2155.8c-165.5 166-370.1 288.5-597.6 344.3-587-143.8-1022.8-732.6-1022.8-1363.8v-601.3l-242.2-241.9 192-192.1 2190.4 2190.5-191.9 192zm-742.1-742.2-83 83-293.7-293.8-160.8 160.8 454.5 454.5 243.8-243.8zm540.6-219 507.9 507.7c76.3-176.2 118.5-369.1 118.5-566v-681.8l-1022.5-454.5-552.9 245.6 788.3 788.1 285.5-285.5 160.8 160.9z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleUnverified);
export default __webpack_public_path__ + "static/media/google-unverified.675e6a0eb42963f19a2e9014dc6a378b.svg";
export { ForwardRef as ReactComponent };